import { useEffect, useRef, useState } from "react";

const VIDEOS = [
  "/videos/hero-loop.mp4",
  "/videos/hero-loop-2.mp4",
  "/videos/hero-loop-3.mp4",
];

const CROSSFADE_MS = 1500;

export function VideoMontage({
  onSlideChange,
}: {
  onSlideChange?: (index: number) => void;
}) {
  const [current, setCurrent] = useState(0);
  const [, setNext] = useState<number | null>(null);
  const [showNext, setShowNext] = useState(false);
  const currentRef = useRef<HTMLVideoElement>(null);
  const nextRef = useRef<HTMLVideoElement>(null);
  const busyRef = useRef(false);

  useEffect(() => {
    const vid = currentRef.current;
    if (!vid) {
      return;
    }

    vid.src = VIDEOS[current]!;
    vid.load();
    vid.play().catch(() => {});
  }, [current]);

  useEffect(() => {
    const vid = currentRef.current;
    if (!vid) {
      return;
    }

    function onTime() {
      if (!vid || busyRef.current) {
        return;
      }
      if (vid.duration - vid.currentTime < CROSSFADE_MS / 1000 + 0.3) {
        busyRef.current = true;
        const n = (current + 1) % VIDEOS.length;
        setNext(n);

        const nVid = nextRef.current;
        if (nVid) {
          nVid.src = VIDEOS[n]!;
          nVid.load();
          nVid.oncanplay = () => {
            nVid.play().catch(() => {});
            setShowNext(true);
            onSlideChange?.(n);

            setTimeout(() => {
              setCurrent(n);
              setNext(null);
              setShowNext(false);
              busyRef.current = false;
            }, CROSSFADE_MS + 200);
          };
        }
      }
    }

    vid.addEventListener("timeupdate", onTime);
    return () => vid.removeEventListener("timeupdate", onTime);
  }, [current, onSlideChange]);

  return (
    <>
      <video
        ref={currentRef}
        muted
        playsInline
        className="absolute inset-0 h-full w-full object-cover"
        style={{
          opacity: showNext ? 0 : 1,
          transition: `opacity ${CROSSFADE_MS}ms ease-in-out`,
          zIndex: 1,
        }}
      />
      <video
        ref={nextRef}
        muted
        playsInline
        className="absolute inset-0 h-full w-full object-cover"
        style={{
          opacity: showNext ? 1 : 0,
          transition: `opacity ${CROSSFADE_MS}ms ease-in-out`,
          zIndex: 0,
        }}
      />
    </>
  );
}
